<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.41,8C7.41,8,10.7,4.71,10.7,4.71C10.89,4.53,11,4.28,11,4C11,3.45,10.55,3,10,3C9.719999999999999,3,9.469999999999999,3.11,9.29,3.29C9.29,3.29,6,6.59,6,6.59C6,6.59,6,4,6,4C6,3.45,5.55,3,5,3C4.45,3,4,3.45,4,4C4,4,4,12,4,12C4,12.55,4.45,13,5,13C5.55,13,6,12.55,6,12C6,12,6,9.41,6,9.41C6,9.41,9.29,12.7,9.29,12.7C9.469999999999999,12.89,9.719999999999999,13,10,13C10.55,13,11,12.55,11,12C11,11.72,10.89,11.47,10.71,11.29C10.71,11.29,7.41,8,7.41,8C7.41,8,7.41,8,7.41,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ChevronBackward',
} as DefineComponent
</script>
